import { Navigate } from "react-router"
import { LocationDetails } from "../components/LocationDetails/LocationDetails"
import { useSearchParams } from "../hooks/useSearchParams"
import { ROUTES } from "../utils/constants"
import { cleanSubtitle } from "../utils/helpers"

export const WatchedLocation: React.FC = () => {
  const { id, title, subtitle } = useSearchParams()

  if (!id) {
    console.error("Invalid parameters", { id })
    return <Navigate to={ROUTES.NOT_FOUND} />
  }

  return (
    <LocationDetails
      location_id={id}
      title={title ?? ""}
      subtitle={cleanSubtitle(title ?? "", subtitle ?? "")}
    />
  )
}
